import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'lg' | 'sm';
}
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  fullWidth = false,
  size = 'lg'
}: CtaButtonProps) {
  const padding = size === 'lg' ? 'px-6 py-[18px] text-[13px] sm:px-8 sm:text-[14px]' : 'px-6 py-3 text-[13px]';
  return <a href={href} className={['inline-flex items-center justify-center text-center rounded-sharp bg-brass font-mono uppercase tracking-label text-ink', 'transition-colors duration-150 ease-out hover:bg-ink hover:text-paper', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink', padding, fullWidth ? 'w-full' : 'w-full sm:w-auto', className].join(' ')} data-id="element-103" data-mp="qjij7pi8gw0z">
      {children}
    </a>;
}